import { useEffect, useState } from "react";
import ModalComponent from "../Modal/ModalComponent";
import "./TagSelector.css";
import TagService from "../../services/TagService";
import { useAuth } from "../../contexts/auth";
import { FaCircleCheck } from "react-icons/fa6";
import Button from "../Button/Button";
import { compareEntities } from "../../utils/entity";
import { LuCheckCheck } from "react-icons/lu";
import { isObjectArray } from "../../utils/array";
import { DynamicIcon } from "../DynamicIcon/DynamicIcon";
import CondominioService from "../../services/CondominioService";

export function TagSelector({
	tags: selectedTags,
	type,
	onTagsChange,
	isOpen,
	onClose,
	onLoading,
	onLoad,
	single = false,
	customFilter,
	filters = {},
	parentId = null,
	...props
}) {
	const { user } = useAuth();
	const [unitTags, setUnitTags] = useState([]);
	const [personTags, setPersonTags] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	async function fetchTags() {
		setIsLoading(true);
		onLoading?.();

		async function fetchScopeTags() {
			return await CondominioService.listScopeTagsByTypes(parentId, [type]);
		}

		async function fetchTags() {
			return await TagService.listTagsByClientAndType(user.userData.selectedOrganizationId, type);
		}

		let response = null;

		if (parentId != null) {
			response = await fetchScopeTags();
			if (response.status === 200 && !Array.isArray(response.data)) {
				response = await fetchTags();
			}
		} else {
			response = await fetchTags();
		}

		const responseData = Array.isArray(response.data) ? response.data : [];
		let tags = [];

		try {
			tags = responseData.sort((a, b) => a.name.localeCompare(b.name));
			if (response.status === 200 && responseData) {
				setUnitTags(
					tags
						.filter(tag => tag.type === 'UNIT')
						.filter(tag => customFilter ? customFilter(tag) : true)
						.filter(tag => filters.sendToDevices != null ? tag.sendToDevices === filters.sendToDevices : true)
						.filter(tag => filters.linkableToUser != null ? tag.linkableToUser === filters.linkableToUser : true)
						.map(tag => ({
							...tag,
						}))
				);
				setPersonTags(
					tags
						.filter(tag => tag.type === 'PERSON')
						.filter(tag => customFilter ? customFilter(tag) : true)
						.map(tag => ({
							...tag,
						}))
				);
			}
		} catch (error) {
			console.log(error);
		}

		onLoad?.(tags);
		setIsLoading(false);
	}

	function onToggleSelect(tag) {
		if (single) {
			onClose();
		}
		if (selectedTags.find(t => compareEntities(t, tag))) {
			onTagsChange(selectedTags.filter(t => !compareEntities(t, tag)))
			return;
		}
		onTagsChange(single ? [tag] : [
			...(selectedTags || []),
			tag,
		])
	}

	function toggleAll() {
		const allTags = [...unitTags, ...personTags];
		if (selectedTags?.length < allTags.length) {
			onTagsChange(isObjectArray(selectedTags) ? allTags : allTags?.map(tag => tag.id));
		} else {
			onTagsChange([]);
		}
	}

	useEffect(() => {
		fetchTags();
	}, [
		parentId,
		type,
	]);

	return (
		<ModalComponent
			modalIsOpen={isOpen}
			modalText={`Selecione ${single ? 'uma etiqueta' : 'as etiquetas'}`}
			handleCancel={() => { onClose(); }}
			hideButtons={true}
		>
			<div className="tag-selector">
				{[...unitTags, ...personTags].length > 0 ? (
					<>
						{[unitTags, personTags]?.filter(tags => tags && tags.length > 0).map((tags, index) => (
							<div key={index} className="tag-column">
								{tags?.map(tag => {
									const isSelected = selectedTags?.find(t => compareEntities(t, tag));
									return (
										<button
											key={tag.externalId}
											type="button"
											className={`tag-item ${isSelected ? 'tag-selected' : ''}`}
											style={{ '--tagColor': tag.color }}
											onClick={e => onToggleSelect(tag)}
										>
											<span>
												{tag.icon ? (
													<DynamicIcon iconName={tag.icon} color={tag.color} size={17} />
												) : (
													<span></span>
												)}
												{tag.name}
											</span>
											{isSelected && (
												<FaCircleCheck />
											)}
										</button>
									);
								})}
							</div>
						))}
					</>
				) : (
					<p className="w-full text-center opacity-40">Nenhuma etiqueta disponível</p>
				)}
			</div>
			<div className="flex justify-center items-center mt-5! gap-2">
				{!single && (
					<Button
						className={"button-white"}
						onClick={(e) => toggleAll()}
						label={selectedTags?.length < [...unitTags, ...personTags].length ? "Selecionar todas" : "Desmarcar todas"}
					/>
				)}
				<Button
					className={"button-white"}
					onClick={onClose}
					label={"Fechar"}
				/>
			</div>
		</ModalComponent>
	);
}